import { render, staticRenderFns } from "./DashboardFormCase.vue?vue&type=template&id=29b86fb4"
import script from "./DashboardFormCase.vue?vue&type=script&lang=js"
export * from "./DashboardFormCase.vue?vue&type=script&lang=js"
import style0 from "./DashboardFormCase.vue?vue&type=style&index=0&id=29b86fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports